import { Avatar, Button } from '@synergy-marine-group/synergy-ui';
import { Field, Form, Formik } from 'formik';
import React, { useState, useEffect } from 'react';
import { Card } from '@material-ui/core';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import addCommentQuery from './queries/addComment';
import getComments from './queries/getComments';
import showAlert from '../../utils/alert';

const validationSchema = Yup.object({
  comment: Yup.string().trim().required('Please Enter a Comment ').max(250, 'Must be 250 characters or less')
});

const Comment = ({ isVendor }) => {
  const { poId } = useParams();
  const [comments, setComments] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const fetchComments = async () => {
    try {
      const { data: fetchedComments } = await getComments(poId, isVendor);
      setComments(fetchedComments);
    } catch (error) {
      console.error(error);
      showAlert('Something went wrong', 'error');
    }
  };
  useEffect(() => {
    fetchComments();
  }, [poId]);

  const handleAddComment = async (comment) => {
    setIsLoading(true);
    const req = {
      comment,
      userName: 'admin',
      purchaseOrderId: poId
    };
    await addCommentQuery(req).then(() => {
      try {
        setIsLoading(false);
        fetchComments();
      } catch (error) {
        setIsLoading(false);
        showAlert('Something went wrong', 'error');
      }
    });
  };

  if (isVendor && comments?.length === 0) return null;

  return (
    <Card className="h-full mx-12">
      <div className="px-8 py-4">
        <Formik
          initialValues={{ comment: '' }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            handleAddComment(values?.comment);
            resetForm();
          }}
        >
          {() => {
            return (
              <div>
                {isVendor ? (
                  <div className="text-gray-100 text-left" hidden={!comments?.length}>Comments</div>
                ) : (
                  <Form>
                    <div className="flex flex-row gap-4 items-end relative">
                      <Field
                        name="comment"
                        component={InputFieldComponent}
                        className="max-w-lg p-1"
                        id="number"
                        label="Comments"
                        autoComplete="off"
                        multiline
                        rows={1}
                      />
                      <div className="ml-2 mb-1">
                        <Button
                          type="submit"
                          className="fit-content p-1.5"
                          rounded
                          size="small"
                          variant="outlined"
                          disabled={isLoading}
                        >
                          Submit Comment
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
                <>{isLoading && <div className="text-xs text-primary-500">Posting Comment ...</div>}</>
                <div className="footer-top comment-scroll custom-scroll pt-4">
                  {comments?.map(({ comment, userName, createdAt }) => (
                    <div className="py-6 flex flex-row">
                      <Avatar className="flex justify-center bg-primary-100 " size="medium" variant="circle">
                        <div className="flex items-center capitalize text-primary-900 font-bold">{userName?.charAt(0)}</div>
                      </Avatar>
                      <div className="px-2 w-1/2">
                        <span className="text-xs font-bold mr-2">{userName}</span>
                        <span
                          className=" text-xs
                                            text-gray-100"
                        >
                          {moment.utc(createdAt).utcOffset('+05:30').fromNow()}
                        </span>
                        <div className="text-xs font-body font-thin my-1 text-gray-500">{comment}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    </Card>
  );
};

export default Comment;
